module.exports = __webpack_public_path__ + "static/what_we_do.4b8a0106.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/what_we_do.png
// module id = 660
// module chunks = 235188726511790